module.exports = __webpack_public_path__ + "img/icon-generic-generic9.ffcc090c.svg";